module.exports = __webpack_public_path__ + "static/media/bg_002.c4d7fece.png";